import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"color":"#606266"} }
const _hoisted_2 = { style: {"margin-top":"10px"} }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "vote-div" }
const _hoisted_5 = { style: {"margin-top":"0px","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_LikeOutlined = _resolveComponent("LikeOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_back_top = _resolveComponent("a-back-top")!
  const _component_the_footer = _resolveComponent("the-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "center-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, {
        class: "center-div",
        style: { background: '#fff', padding: '75px 50px 50px 50px', margin: 0, minHeight: '720px' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            hoverable: false,
            bordered: true,
            style: {"padding":"20px"},
            bodyStyle: { padding: '5px' },
            type: 'inner',
            class: "card"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.article.title), 1),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_a_typography_paragraph, null, {
                    default: _withCtx(() => [
                      _createElementVNode("blockquote", null, _toDisplayString(_ctx.article.description), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", null, "阅读数：" + _toDisplayString(_ctx.article.viewCount), 1),
                  _createTextVNode("     "),
                  _createElementVNode("span", null, "点赞数：" + _toDisplayString(_ctx.article.voteCount), 1)
                ]),
                _createVNode(_component_a_divider, { style: {"height":"2px","background-color":"#9999cc"} })
              ]),
              _createElementVNode("div", {
                class: "wangeditor",
                innerHTML: _ctx.html
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  shape: "round",
                  size: 'large',
                  onClick: _ctx.vote
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_LikeOutlined),
                    _createTextVNode("  点赞：" + _toDisplayString(_ctx.article.voteCount), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_back_top, { type: "default" }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_the_footer)
      ])
    ]),
    _: 1
  }))
}